// base component
import { TagComponent } from './tag.component';

// components

export const TagModule = angular.module('topbroker.tag', [])
  .component('tag', TagComponent)
  .name;
